import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';

// 1. 스타일이 적용된 컴포넌트 정의
const StyledTopBar = styled.header`
  width: 100%;
  background-color: white;
  border-bottom: 0.125rem solid #545454;
  display: flex;
  justify-content: space-between; /* 양 끝으로 배치 */
  align-items: center;
`;

const WebTitle = styled.div`
  font-family: 'Esamanru', sans-serif;
  font-size: 2.25rem;
  color: black;
  letter-spacing: -0.08rem;
  padding: 2.5rem 3.25rem;
`;

const AuthWrapper = styled.div`
  padding: 0 3.25rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const GoogleBtn = styled.button`
  padding: 0.6rem 1.2rem;
  border: 0.1rem solid #ccc;
  border-radius: 0.4rem;
  background: white;
  font-size: 1.4rem;
  cursor: pointer;
  font-weight: bold;
  &:hover { background: #f5f5f5; }
`;

const LogoutBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1.2rem;
`;

const UserName = styled.strong`
  font-size: 1.4rem;
`

export default function TopBar() {
  const { user, login, logout } = useAuth(); // 필요한 것만 쏙쏙

  const onLogoutClick = () => {
    const isConfirmed = window.confirm("로그아웃 하시겠습니까?");
        
    if (isConfirmed) {
      logout()
    }
  }

  return (
    <StyledTopBar>
      <WebTitle>프로야구 스쿼드 메이커</WebTitle>
      <AuthWrapper>
        {user ? (
          <>
            <UserName>{user.user_metadata.full_name}</UserName>
            <LogoutBtn onClick={onLogoutClick}>로그아웃</LogoutBtn>
          </>
        ) : (
          <GoogleBtn onClick={login}>Google 로그인</GoogleBtn>
        )}
      </AuthWrapper>
    </StyledTopBar>
  );
}